<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created () {
    const that = this
    window.addEventListener("resize", function () {
      return (() => {
        that.$store.state.WindowWidth = document.body.clientWidth;
      })();
    });
  }
};
</script>

<style>
@import "./common/index.css";
@import "./common/animation.css";
.about_line {
  width: 47px;
  height: 1px;
  margin: 14px auto 0;
}
.el-carousel__container .el-carousel__arrow {
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue